import { DarkTheme, LightTheme } from '@mercedes-benz/mui5-theme';
import HomeIcon from '@mui/icons-material/Home';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import BarChartIcon from '@mui/icons-material/BarChart';
import React from 'react';
import { HomePage } from './pages/HomePage';
import { DashboardPage } from './pages/Dashboard/DashboardPage';
import AddIcon from '@mui/icons-material/Add';
import { TLPHomePage } from './pages/TLP/TLPHomePage';




const AppConfig = {
  appName: 'Delivery Promise',
  sideBarWidth: 250,
  defaultTheme: DarkTheme,
  defaultRoute: 'home'
};

AppConfig.pages = [
  {
    name: 'Home',
    component: <HomePage />,
    sideBarIcon: <HomeIcon />,
    url: 'home',
  },
  {
    name: 'Dashboard',
    component: <DashboardPage />,
    sideBarIcon: <BarChartIcon />,
    url: 'Dashboard',
  },
];

AppConfig.homeSubPages = [
  {
    name: 'TLP',
    // component: <TLPHomePage />,
    url: 'https://tlp.supplier.mercedes-benz.com/',
    image: '/resources/TLP.jpg',
    product: 'Outbound Planning',
    auth: ["LP_Admin","LP_TLP"],
  },
  {
    name: 'Forecast Analytics',
    url: 'https://sgdem0011744.con-02.emea.dc.corpintra.net/reports/powerbi/OBL Reports/Forecast Analytics/Bedarfsmanagement?rs:embed=true',
    image: '/resources/ForecastAnalytics.jpg',
    product: 'Outbound Planning',
    auth: ["LP_Admin","LP_TLP"],
  },
  {
    name: 'OBL Dashboard',
    url: 'https://sgdem0011744.con-02.emea.dc.corpintra.net/Reports/browse/OBL%20Reports/OBL%20-%20Dashboard',
    image: '/resources/OBL_Dashboard.jpg',
    product: 'Problem Identification',
    auth: ["LP_Admin","LP_OBLDashboard"],
  },
  {
    name: 'T&T Vessel',
    url: 'https://sgdem0011744.con-02.emea.dc.corpintra.net/reports/powerbi/OBL%20Reports/OBL%20-%20Dashboard/Schiffstracking%20Dashboard?rs%3Aembed=true',
    image: '/resources/Vessel_Tracking.jpg',
    product: 'Problem Identification',
    auth: ["LP_Admin","LP_OBLDashboard"],
  },
  {
    name: 'T&T Truck & Train',
    url: 'https://www.shippeo.com/de',
    image: '/resources/SHIPPEO_LOGO.jpg',
    product: 'Problem Identification',
    auth: ["LP_Admin","LP_OBLDashboard"],
  },
  {
    name: 'Unblock Management',
    url: 'https://app.powerbi.com/groups/2176e017-21a0-452b-9e36-c038176a5e3d/reports/e51261ad-e846-490e-9bb4-a35dd6a6ad87/ReportSectionf6225b36079696fab3a1?language=en-EN&experience=power-bi',
    image: '/resources/Unblock_Management.jpg',
    product: 'UBM',
    auth: ["LP_Admin","LP_UBM"],
  },
  {
    name: 'WebApp',
    url: 'https://ms-eu-web-sdl-ubm-01-prd.azurewebsites.net/#/home',
    image: '/resources/WebApp.jpg',
    product: 'UBM',
    auth: ["LP_Admin","LP_UBM"],
  },
  {
    name: 'Process Mining',
    url: 'https://ems.mercedes-benz.celonis.cloud/',
    image: '/resources/celonis.jpg',
    product: 'Control Tower',
    auth: ["LP_Admin"],
  },
  
]

export { AppConfig };
